/** H5 & app 支付类型特殊说明：
 * 1. app & canAlipay 显示 AlipayStripe
 * 2. H5 & 阿里浏览器 显示 AlipayCitcon
 * 3. H5 & 微信浏览器 显示 Wechat || WechatCitcon (重新采用citcon)
 * 4. 信用卡stripe取消
 * 5. 同一类型不同key 因为兼容app版本目前都可能显示
 * */
export enum PaymentMethod {
  /**信用卡 */
  Card = 'D',
  /**paypal */
  PayPal = 'P',
  PayPalStripe = 'J',
  /**paypal valut(订单包含订阅商品) */
  PayPalValut = 'R',
  /**wechat pay */
  Wechat = 'C',
  WechatCitcon = 'I',
  WechatStripe = 'F',
  // Google Pay Braintree替换原来的alipay
  GooglePayBrainTree = 'A',
  /**alipay */
  AlipayCitcon = 'K',
  /**stripe alipay */
  AlipayStripe = 'E',
  /**apple pay */
  Apple = 'T',
  AppleBrainTree = 'L',
  //brainTree的信用卡
  BrainTreeCard = 'B',
  Venmo = 'V',
  NativePayPal = 'Q',
  // forage 支付 EBT
  Ebt = 'M',
  EbtLatino = 'Q',
  EbtLatinoFullyHost = 'N',
  CashApp = 'H',
  EbtSdk = 'O',
  MkplPaypal = 'G'
}

export enum PAY_PLATFORM {
  stripe = 'stripe',
  brainTree = 'braintree'
}
